import http from './httpRequest.js'

export function getMyTodo(params) {
	return http({
		url: '/todo/my-todo',
		method: 'post',
		data: params,
    otherApis: true
	})
}

// 我的已完成代办
export function getMyCompleteTodo(params) {
	return http({
		url: '/todo/my-todo-complete',
		method: 'post',
		data: params,
    otherApis: true
	})
}
// 我发起的
export function getMyLaunchTodo(params) {
	return http({
		url: '/todo/my-launch',
		method: 'post',
		data: params,
    otherApis: true
	})
}
// 历史
export function getMyHistoryTodo(params) {
	return http({
		url: '/todo/my-launch-history',
		method: 'post',
		data: params,
    otherApis: true
	})
}

export function addTask(params) {
	return http({
		url: '/todo/submit',
		method: 'post',
		data: params,
    otherApis: true
	})
}

export function deleteTask(params) {
	return http({
		url: '/todo/delete',
		method: 'post',
		data: params,
    otherApis: true
	})
}

export function editTaskStatus(params) {
	return http({
		url: '/todo/updateStatus',
		method: 'post',
		data: params,
    otherApis: true
	})
}
